import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-wishtime-group-header',
  templateUrl: './wishtime-group-header.component.html',
  styleUrls: ['./wishtime-group-header.component.scss'],
})
export class WishtimeGroupHeaderComponent {
  @Input() wishTimeKey!: string;
  @Input() groupItems!: any[];
  @Input() userLang$!: Observable<string>;
  @Input() selectedStore: any;
  @Input() isTimeShowDisabled?: boolean;
  @Input() variant: 'checkout' | 'catalog' = 'checkout';
}
